export default {"src":"/_next/static/media/breezeup-logo.7704cf05.svg","height":47,"width":59,"blurWidth":0,"blurHeight":0};